import devLogger from 'react-utils/devLogger';
import { FILE_MANAGER_WIDTH, GLOBAL_NAV_HEIGHT } from '../constants/sizes';
export const calculateGlobalStyles = ({
  isOpen,
  layoutType,
  skipOpenAnimation
}) => {
  if (layoutType === 'sidebar') {
    if (isOpen) {
      return {
        width: '408px !important',
        overflow: 'hidden',
        transition: skipOpenAnimation ? 'none' : 'width 0.5s ease-in'
      };
    } else {
      return {
        width: '0px !important',
        overflow: 'hidden',
        transition: skipOpenAnimation ? 'none' : 'width 0.5s ease-in'
      };
    }
  } else {
    if (isOpen) {
      return {
        width: 400,
        overflow: 'hidden'
      };
    } else {
      return {
        width: 0,
        overflow: 'hidden'
      };
    }
  }
};
export const calculateIframesStyles = ({
  isCopilotExpanded,
  isOpen,
  layoutType,
  previousOpenState,
  skipOpenAnimation,
  isFileManagerOpen,
  theme,
  isUngatedForUIRefresh
}) => {
  // Override our iframe style props in the nav
  const commonStyles = isUngatedForUIRefresh ? {
    background: 'linear-gradient(#ffffff,#ffffff,#ffffff) padding-box,linear-gradient(#ff4800,#fc0849,#d20688) border-box',
    border: '1px solid transparent',
    borderRadius: isCopilotExpanded ? '0px' : '16px',
    width: isCopilotExpanded ? 'calc(100% - var(--global-nav-vertical-nav-width, 0))' : isFileManagerOpen ? FILE_MANAGER_WIDTH : 400,
    height: isCopilotExpanded ? `calc(100vh - var(--global-nav-height, ${GLOBAL_NAV_HEIGHT}px))` : `calc(100vh - var(--global-nav-height, ${GLOBAL_NAV_HEIGHT}px) - 16px)`,
    // 16px to accoutn for our 8px margins
    margin: isCopilotExpanded ? '0' : '8px 8px 8px 0',
    boxShadow: `0 8px 32px 0 rgba(0, 0, 0, 0.12),
      0 230px 64px 0 rgba(0, 0, 0, 0.00),
      0 147px 59px 0 rgba(0, 0, 0, 0.01),
      0 83px 50px 0 rgba(0, 0, 0, 0.04),
      0 37px 37px 0 rgba(0, 0, 0, 0.04),
      0 9px 20px 0 rgba(0, 0, 0, 0.04),
      0px -20px 0px 8px ${theme.color['specialty-scrim-alt']},
      0px 20px 0px 8px ${theme.color['specialty-scrim-alt']}`
  } : {
    background: 'linear-gradient(#ffffff,#ffffff,#ffffff) padding-box,linear-gradient(#ff4800,#fc0849,#d20688) border-box',
    borderTop: isCopilotExpanded ? 'none' : '1px solid transparent',
    borderLeft: isCopilotExpanded ? 'none' : '1px solid transparent',
    borderBottom: isCopilotExpanded ? 'none' : '1px solid transparent',
    borderRight: 'none',
    borderRadius: isCopilotExpanded ? '0px 0px 0px 0px' : '9px 0px 0px 9px',
    boxShadow: 'none',
    width: isCopilotExpanded ? 'calc(100% - var(--global-nav-vertical-nav-width, 0))' : isFileManagerOpen ? FILE_MANAGER_WIDTH : 400,
    zIndex: 1070
  };
  const isOpening = isOpen && previousOpenState === false;
  const isClosing = !isOpen && previousOpenState === true;

  // If we're opening to expanded view, we'll use the translateX animation
  if (layoutType === 'sidebar') {
    if (skipOpenAnimation) {
      return Object.assign({}, commonStyles, {
        right: 0,
        transition: 'none',
        transform: 'none'
      });
    }
    if (isCopilotExpanded && !isClosing) {
      return Object.assign({}, commonStyles, {
        right: 0,
        transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
        // if its opening (from closed) we use the transform to animate the sidebar opening
        // If its minimizing we use the width to animate the collapse
        // If its closing, we do NOT animate (see return below)
        transition: isOpening ? 'transform 0.5s ease-in' : 'width 0.5s ease-in'
      });
    }
    return Object.assign({}, commonStyles, {
      right: isOpening || !isOpen ? 'auto' : 0,
      transition: isOpen ? 'width 0.5s ease-in' : 'none',
      transform: 'none'
    });
  } else {
    if (layoutType !== 'panel' && layoutType !== 'panel-with-scroll') {
      devLogger.warn({
        key: 'copilot-layout-type',
        message: `Using unsupported nav copilot layout type ${layoutType}`
      });
    }
    if (skipOpenAnimation) {
      return Object.assign({}, commonStyles, {
        right: 0,
        transform: 'none',
        transition: 'none'
      });
    }
    return Object.assign({}, commonStyles, {
      right: 0,
      transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
      // When we expand the open copilot we want the width transition to animate
      // the expansion. If we're opening from a closed state we use the
      // transform instead
      transition: isOpening ? 'transform 0.5s ease-in' : 'width 0.5s ease-in'
    });
  }
};